module.exports = __webpack_public_path__ + "img/stopwatch.498e7857.png";